import styled from 'styled-components';
import { Stack as StackCommon } from '../../../../../../Stack';

export const Stack = styled(StackCommon)<{ height: number }>`
  height: ${({ height }) => `${height + 40}px`};
  margin-bottom: 16px;
  width: 100%;
`;

export const FlippingCardContainer = styled.div`
  height: 100%;
  width: 100%;
`;

export const Container = styled.div<{
  cardHeight: number;
}>`
  width: 100%;
  height: ${({ cardHeight }) => cardHeight}px;
  transition: height 0.4s;
  &:hover,
  &[aria-pressed='true'] {
    height: ${({ cardHeight }) => cardHeight + 20}px;
  }
`;
